import React from 'react';
import { ListItem, ListItemText, List } from '@mui/material';
import PropTypes, { object } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import GenericDialog from '../../GenericDialog';

const QuestionTypeList = ({
  isOpen, doClose, onClick, types,
}) => (
  <GenericDialog
    isOpen={isOpen}
    onRequestClose={doClose}
    maxWidth="xs"
  >
    <div className="pa2">
      <h1 className="f3 lh-title">
        <FormattedMessage id="questiontypelist.title" />
      </h1>
      <List>
        {types.map((questionType) => (
          <ListItem
            key={questionType.id}
            button
            onClick={() => onClick(questionType)}
          >
            <ListItemText primary={questionType.text} />
          </ListItem>
        ))}
      </List>
    </div>
  </GenericDialog>
);

export default QuestionTypeList;

QuestionTypeList.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  doClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  types: PropTypes.arrayOf(object).isRequired,
};
